<script>
import { mapState } from 'vuex'
import Request from '@src/mixins/request'
import headers from '@src/data/headers.json'

export default {
  metaInfo: {
    title: 'Rate Plan',
    meta: [{ name: 'description', content: 'Rate Plan' }],
  },

  mixins: [Request],

  data() {
    return {
      headers: headers.ratePlan,
      items: [],
      color: 'gold',
      deleteDialog: false,
      deleteId: null,
    }
  },

  computed: {
    ...mapState('app', {
      propertyId: (state) => state.currentProperty.id,
    }),
    // propertyId() {
    //   return this.$store.state.app.currentProperty.id
    // },
    tableHeaders() {
      const th = this.headers.slice(0)
      th.push({ text: 'Actions', sortable: false, align: 'right' })
      return th
    },
  },

  mounted() {
    this.fetchItems()
  },

  methods: {
    async fetchItems() {
      this.items = await this.fetchData({
        url: this.endpoint.ratePlan.list,
        data: { propertyId: this.propertyId },
      })
    },
    emitEvent(item = {}) {
      this.$emit('event', { currentView: 'RatePlanDetail', item })
    },
    deleteItem(item) {
      this.deleteDialog = true
      this.deleteId = item.id
    },
    closeDialog() {
      this.deleteDialog = false
      this.deleteId = null
    },
    async onDelete() {
      await this.updateData({
        url: this.endpoint.ratePlan.delete,
        data: {
          id: this.deleteId,
          propertyId: this.propertyId,
        },
      })
      this.fetchItems()
      this.closeDialog()
    },
  },
}
</script>

<template>
  <BaseView title="Rate Plan" :color="color">
    <!-- Slot toolbar-actions -->
    <VBtn
      slot="toolbar-actions"
      :color="color"
      depressed
      dark
      :to="{ name: 'rate-plan-detail', params: { ratePlanId: 'new' } }"
    >
      Add
    </VBtn>
    <!-- End of Slot toolbar-actions -->

    <VDataTable
      :headers="tableHeaders"
      :items="items"
      :loading="loading ? color : false"
      hide-actions
    >
      <!-- Item Slot -->
      <template slot="items" slot-scope="props">
        <td
          v-for="(header, index) in headers"
          :key="`${header.text}-${index}`"
          :class="{ 'text-xs-right': header.align && header.align === 'right' }"
        >
          {{ props.item[header.value] }}
        </td>
        <td class="text-xs-right">
          <!-- Edit Icon -->
          <VBtn
            flat
            icon
            :to="{
              name: 'rate-plan-detail',
              params: { ratePlanId: props.item.id },
            }"
          >
            <VIcon small class="mr-2">
              edit
            </VIcon>
          </VBtn>
          <!-- End of Edit Icon -->

          <!-- Delete Icon -->
          <VIcon small @click="deleteItem(props.item)">
            delete
          </VIcon>
          <!-- End of Delete Icon -->
        </td>
      </template>
      <!-- End of Item Slot -->
    </VDataTable>

    <VDialog v-model="deleteDialog" max-width="290px" persistent>
      <VCard>
        <VCardTitle class="headline">Delete entry</VCardTitle>

        <VCardText>Are you sure want to delete this entry?</VCardText>

        <VCardActions>
          <VSpacer />
          <VBtn color="grey" flat @click="closeDialog">
            Cancel
          </VBtn>

          <VBtn :color="color" flat @click="onDelete">
            Delete
          </VBtn>
        </VCardActions>
      </VCard>
    </VDialog>
  </BaseView>
</template>
